module.exports = __webpack_public_path__ + "img/anomaly_explanation.7c8e48f1.png";